import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommandBase, FilteredCommand, MultiselectCommand } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { invoiceCommand } from '../../command/unpaid-invoice';
import { InvoiceService } from '../data/invoice.service';

@Injectable()
export class DeleteInvoicesCommandHandler implements ICommandHandler {
  constructor(private _dataService: InvoiceService) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof MultiselectCommand) {
      if (!command.items || !command.itemsSource) return false;
      return command.id === invoiceCommand.deleteMany;
    }
    if (command instanceof FilteredCommand) {
      return command.filterProvider && command.totalAffectedItemsControlValue > 0;
    }
    return false;
  }

  execute(command: CommandBase): Observable<boolean> {
    if (command instanceof MultiselectCommand) {
      return this._dataService.deleteMany(command.items.map(item => item.id)).pipe(
        map(() => {
          command.items.forEach(item => {
            const index = command.itemsSource.indexOf(item);
            if (index >= 0) {
              command.itemsSource.splice(index, 1);
            }
          });
          return true;
        })
      );
    }
    if (command instanceof FilteredCommand) {
      return this._dataService
        .deleteFiltered(
          command.filterProvider.filterState,
          command.includedIds,
          command.excludedIds,
          command.totalAffectedItemsControlValue
        )
        .pipe(map(() => true));
    }
  }
}
